export default class LaterListEvents {

    static LaterListModifiedEvents : Array<any> = [];

    static addLaterListModifiedEvent(event: any) {
        LaterListEvents.LaterListModifiedEvents.push(event);
    }

    static callLaterListModifiedEvents() {
        LaterListEvents.LaterListModifiedEvents.forEach((event: any) => {
            event();
        });
    }
 static removeLaterListModifiedEvent(eventToRemove: () => void) {
        LaterListEvents.LaterListModifiedEvents = LaterListEvents.LaterListModifiedEvents.filter(
            (event) => event !== eventToRemove
        );
    }
}
